<template>
  <div id="map">
    <div class="cartof3"></div>
    <div class="cartof2"></div>
    <div class="cartof"></div>
    <p class="title font1">{{$t('contactMap.title')}}</p>
    <div class="columns">
      <div class="column is-7">
        <gmap-map :center="center" :zoom="17" class="google-map box">
          <gmap-marker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :clickable="true"
            @click="center=m.position"
          ></gmap-marker>
        </gmap-map>
      </div>

      <div class="column details">
        <h2 class="font1">{{$t('contactMap.lc_title')}}</h2>
        <div class="date">
          <span>{{$t('contactMap.address1')}}</span>
          <br />
          <span>{{$t('contactMap.address2')}}</span>
          <br />
          <span>{{$t('contactMap.address3')}}</span>
          <br />
          <span>{{$t('contactMap.telephone')}}</span>
          <br />
          <span>{{$t('contactMap.email')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      center: { lat: 44.43872, lng: 26.05015 },
      markers: [
        {
          position: { lat: 44.43872, lng: 26.05015 },
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
$svg-width: 32vw;
$svg-padding: calc(30.5vw * 6 / 4); //nu poti pune variabile in calc()
$svg-displacement: -4vw; //ca sa nu apara marginea

#map {
  padding-top: 15vh;
}
div {
  text-align: center;
  margin-bottom: 30px;
}

.title {
  margin: auto;
  margin-bottom: 3%;
  padding-top: 1%;
  font-weight: normal;
  color: white;
  font-size: 58px !important;
  font-family: "Acumin Variable Concept" !important ;
}

h2 {
  font-size: 2.5vw;
  font-weight: normal;
  margin-bottom: 5%;
  color: white;
  font-family: "Acumin Variable Concept";
}

.cartof {
  position: absolute;
  bottom: 110vh;
  background-size: cover;
  width: $svg-width;
  padding: 0;
  padding-bottom: $svg-padding;
  left: $svg-displacement;
  transform: scale(0.85);
  background-image: url("../../assets/images/cartofLeft.svg");
}

.cartof2 {
  position: absolute;
  background-size: cover;
  width: $svg-width;
  top: 44vw;
  padding: 0;
  padding-bottom: $svg-padding;
  right: $svg-displacement;
  transform: scale(0.85);
  background-image: url("../../assets/images/cartofRight.svg");
  // offset-anchor: 20% 80%;
}

.cartof3 {
  position: absolute;
  display:none;
  background-size: cover;
  width: $svg-width;
  bottom: 110vw;
  padding: 0;
  padding-bottom: $svg-padding;
  right: $svg-displacement;
  transform: scale(0.85);
  background-image: url("../../assets/images/cartofRight.svg");

  @media screen and (max-width: 768px) {
  display: block;

}
}

span {
  color: white;
  font-size: 2.5vw;
  font-family: "Acumin Variable Concept";
  line-height: 130%;
}

.details {
  margin-top: 3%;
  margin-left: -10%;
}

.google-map {
  width: 75%;
  height: 95%;
  min-height: 450px;
  margin-left: 13%;
  margin-top: 6%;
  bottom: 4%;
  border-radius: 70px;
  overflow: hidden;
  background-color: #0d2a4c;
}

.vue-map {
  margin-bottom: 0px !important;
}

@media screen and (max-width: 1024px) {
  .columns {
    display: flex;
    flex-direction: column;
  }

  .google-map {
    min-height: initial;
    width: 85vw;
    height: 35vh;
    margin-left: 5vw;
    margin-bottom: -2vh;
    border-radius: 31.5px;
  }

  .title {
    font-size: 3.5vh !important;
  }

  span {
    font-size: 2.6vh;
    line-height: 160%;
  }

  h2 {
    font-size: 3vh;
    margin-bottom: 1.5%;
  }

  .details {
    position:relative;
    margin-top: 0.5vh;
    margin-left: -1%;
    .date {
      margin-bottom: -2.5vh;
    }
  }
}
</style>